<template>
  <div>
    <div class="card-box-no-shadow flex justify-center ">
        <div class="flex my-102 justify-between items-center w-9/12 lg:flex-col">
          <div class="mx-20 lg:mx-0 lg:my-20">
            <h1 class="font-bold text-24">{{ $t('contact_us') }}</h1>
          <div class="border-1 bg-default rounded-sm flex items-center p-15 my-10">
            <call-icon width="50" class="w-1/12"/>
            <a href="tel:+9858793" class="phone-call">
               021 58793 </a>
          </div>
          <div class="border-1 bg-default rounded-sm flex items-center p-15 my-10">
            <sms-icon width="50" class="w-1/12" />
             <a href="mailto:info@Novaday.ir"  class="text-sm font-medium mx-10 w-11/12">
                info@Novaday.ir </a>
          </div>
          <div class="border-1 bg-default rounded-sm flex items-center p-15 my-10">
            <global-icon width="50" class="w-1/12"/>
            <a href="https://novaday.ir/" target="_blank" class="text-sm font-medium mx-10 w-11/12">
                Novaday.ir</a>
          </div>
          <div class="border-1 bg-default rounded-sm flex items-center p-15 my-10">
            <location-icon width="50" class="w-1/12"/>
            <p class="text-sm font-medium mx-10 w-11/12">
                 Shahrak-e-Shahab Sang, Tehran, Tehran Province,
              Improvement of Iran Wood Industry Industrial Town, Novaday Company.
            </p>
          </div>
        </div>
        <div class="mx-20 lg:mx-0 lg:my-20">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1621.1114434535468!2d51.19945678360436!3d35.64687983875547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8df9135cff02e3%3A0x5b02e0a0cab5a469!2zTm92YWRheSBDb21wYW55INi02LHaqdiqINmG2YjYp9iv24w!5e0!3m2!1sen!2ssc!4v1652698012564!5m2!1sen!2ssc"
            width="400"
            height="364"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallIcon from '../assets/icons/vue/call.vue';
import SmsIcon from '../assets/icons/vue/sms.vue';
import GlobalIcon from '../assets/icons/vue/global.vue';
import LocationIcon from '../assets/icons/vue/location.vue';

export default {
  name: 'ContactUs',
  components: {
    CallIcon,
    SmsIcon,
    GlobalIcon,
    LocationIcon,
  },
};
</script>

<style lang="css" scoped>
.phone-call{
  @apply text-sm font-medium mx-10 w-max;
  direction: ltr;
}
</style>
